module.exports = __webpack_public_path__ + "img/compensation.69143a7.svg";